import isDecimalSelection from './isDecimalSelection';

interface IFormatValue {
    value: string;
    cursorPosition: number;
}

const formatInput = (
    inputValue: string,
    currencyPrecision: number,
    cursorPosition: number,
): IFormatValue => {
    let newValue = inputValue;
    let newCursorPosition = cursorPosition;

    if (!inputValue) {
        newValue = (0).toFixed(currencyPrecision);
        newCursorPosition = 1;
    } else if (currencyPrecision) {
        // "X.XXX" => "X.XX"
        newValue = inputValue
            .replace(/[^\d.]/, '')
            .substring(0, inputValue.indexOf('.') + currencyPrecision + 1);

        const decimalSelected = isDecimalSelection(inputValue, cursorPosition);

        if (inputValue.charAt(0) === '.') {
            // "|.XX" -> "0|.XX"
            newValue = `0${newValue}`;
            newCursorPosition = 1;
        } else if (/^0{2,}\./.test(inputValue)) {
            // "0|0.XX" -> "0|.XX"
            newValue = newValue.replace(/^0+/, '0');
            newCursorPosition = newValue.indexOf('.');
        } else if (inputValue.charAt(0) === '0' && !decimalSelected) {
            // "0|X.XX" -> "|X.XX"
            // "0X|.XX" -> "X|.XX"
            newValue = newValue.replace(/^0+/, '');
            newCursorPosition = cursorPosition === 1 ? 0 : 1;
        }
    }

    return {
        value: newValue,
        cursorPosition: newCursorPosition,
    };
};

export default formatInput;
